import { Tab } from '@yleisradio/areena-types';
import { ChannelHeader } from 'components/Guide/ChannelHeader/ChannelHeader';
import { ChannelSelectionMenu } from 'components/Guide/ChannelSelectionMenu/ChannelSelectionMenu';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { isListArray } from 'utils/content';
import { Channel } from './Channel';

interface SelectableChannelProps {
  channel: Tab;
  isFutureDate: boolean;
  isToday: boolean;
  showExpired: boolean;
}

export const SelectableChannel = (props: SelectableChannelProps) => {
  const { persistentState, image, title = '' } = props.channel;

  const channelContent = isListArray(props.channel.content)
    ? props.channel.content
    : [];

  const [storedChannel, setStoredChannel] = useLocalStorage<string | undefined>(
    persistentState?.key && `guide/regional-channel/${persistentState.key}`,
    persistentState?.id && persistentState.id
  );

  const selectedChannel = channelContent.find(
    (c) => c.persistentState?.id === storedChannel
  );

  const handleChannelSelect = (channelId: string) => {
    setStoredChannel(channelId);
  };

  const channelControl = selectedChannel?.controls?.find(
    (c) => c.destination?.type === 'service'
  );

  const currentChannelContent = selectedChannel || channelContent[0];

  return currentChannelContent ? (
    <Channel
      isToday={props.isToday}
      image={props.channel.image}
      showExpired={props.showExpired}
      channelContent={currentChannelContent}
      title={currentChannelContent.title}
      isFutureDate={props.isFutureDate}
      channelHeader={(headingId) => (
        <ChannelHeader
          image={channelControl?.image || image}
          title={title}
          headingId={headingId}
        >
          <ChannelSelectionMenu
            onSelect={handleChannelSelect}
            selectedChannel={storedChannel}
            channels={channelContent}
          />
        </ChannelHeader>
      )}
    />
  ) : null;
};
